export const SET_PAGE_TEMPLATES_DATA = '[PAGE_TEMPLATES] SET_PAGE_TEMPLATES_DATA';

export const setPageTemplatesData = (data) => ({
  type: SET_PAGE_TEMPLATES_DATA,
  payload: data,
});
